import { Box, Button, Grid, Paper, TextField } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

import * as R from 'ramda'
import React, { FC, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import URI from 'urijs'

import config from '../../config'

const StyledPaper = styled(Paper)`
  width: 100%;
  margin: 10px 0px;
  padding: 10px;
  display: grid;
  grid-template-columns: 50% 50%;
`

const BlogListHandlerBar: FC<Record<string, unknown>> = () => {
  const { pathname } = useLocation()
  const history = useHistory()

  const [keywordFilter, setKeywordFilter] = useState('')

  const handleTextChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setKeywordFilter(event.target.value as string)
  }

  const handleFilter = () => {
    if (R.not(R.isEmpty(keywordFilter))) {
      history.push(
        pathname +
          '?' +
          URI.buildQuery({
            page: 1,
            limit: config.api.defaultQuery.limit,
            sortBy: config.api.defaultQuery.sortBy,
            sortDirection: config.api.defaultQuery.sortDirection,
            q: keywordFilter
          })
      )
    }
  }

  return (
    <Grid container style={{ width: '100%' }} alignItems="stretch">
      <StyledPaper>
        <Box display="flex" justifyContent="flex-start" alignItems="enter">
          <Box width={200}>
            <TextField fullWidth onChange={handleTextChange} />
          </Box>
          <Box width={100} marginLeft="20px">
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={handleFilter}
            >
              Filter
            </Button>
          </Box>
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => history.push('/blog/create')}
          >
            Create Blog
          </Button>
        </Box>
      </StyledPaper>
    </Grid>
  )
}

export default BlogListHandlerBar
